export const AUTH_TYPE = {
  CHECKED_TOKEN: 'CHECKED_TOKEN',
  RECEIVED_USERPRIVS: 'RECEIVED_USERPRIVS',
  RECEIVED_USERROLE: 'RECEIVED_USERROLE',
};
